// frontend/src/pages/Workbooks.jsx

import React, { useState } from 'react';
import { readPDF } from '../../components/utils/pdfReader';
// import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import './styles/EBooks.css';

const DownloadWorkbooks = () => {
    const [pdfUrl, setPdfUrl] = useState('');

    const handleReadPDF = (pdfFileName) => {
      const pdfUrl = `http://localhost:3000/pdfs/${pdfFileName}.pdf`;
        readPDF(pdfUrl, pdfFileName);
    };
    
    // const amazonBookLink = "https://www.amazon.in/-/hi/Sanjeev-Kumar-ebook/dp/B0CSX6S86D";
    // const dukaanBookLink = "https://mydukaan.io/think5whys/products/think5whys-rca?sku_id=50454286";

    return (
        <MainLayout>
            <div><h3 className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>Learnings - Download Worbooks</h3></div>
            <div className="ebooks-container">
                <h1 className="ebooks-heading text-white">Download Workbooks</h1>
                <p className="text-white">
                    Together, these components create a structured approach to problem-solving using the 5 Whys Analysis, guiding you from problem identification through the implementation and tracking of solutions.
                    <br/>The Journey starts with the Problem Statement
                    <br/>After that the following steps are undertaken
                    <br/>Why 1, Why 2, Why 3, Why 4, Why 5 Analysis, Root Cause Analysis
                    <br/>Dialogue Tree
                    <br/>Probable Solutions, Solution Action Log, Before & After RCA
                    <br/><br/>Useful Navigations -
                    <br/>One-View Format 1, 2, 3, 4, 5 and Index
                    <br/>Save Workbook in PDF and share with others
                </p>
                <div className="empty-row" style={{ height: '20px' }}></div>
                <div className="button-container">
                    <button className="read-button" onClick={() => handleReadPDF('Think5Whys Step-by-Step Reusable Excel Workbook.xlsx')}>
                    Think5Whys Step-by-Step Reusable Excel Workbook
                    </button>
                    <button className="read-button" onClick={() => handleReadPDF('Think5Whys Blank Reusable Excel Workbook.xlsx')}>
                    Think5Whys Blank Reusable Excel Workbook
                    </button>
                </div>
                {/* <a href={amazonBookLink} target="_blank" rel="noopener noreferrer" className="amazon-button">
                    Buy from Amazon
                </a>
                <a href={dukaanBookLink} target="_blank" rel="noopener noreferrer" className="dukaan-button">
                    Buy from Dukaan
                </a> */}
            </div>
        </MainLayout>
    );
};

export default DownloadWorkbooks;
